import React, { useEffect, useState } from 'react'
import ErrorTooltip from 'Components/ErrorTooltip';
import ToolTip from 'Components/ToolTip';
import { TooltipMsg } from 'Components/ToolTipMessage';
import { Field, FieldProps, useFormikContext } from 'formik';
import { Card, CardBody, CardHeader, Col, Input, Label, Row } from 'reactstrap';
import env from "environment_system/env_system";
import { ReportingEvents } from 'shared/constants';
import PopUp from 'Components/PopUp';
import { RootState } from 'index';
import { useSelector } from 'react-redux';
import { useEditReport } from 'VesselReportingInfo/EditCompletedReports/EditReportProvider';

interface ContainerDetailsProps {
    alertBool: boolean;
    handleCargoOnboardBlur: any,
    AmountOfCargoDischagedOnBlur: any,
    containerChangeState: string,
    setContainerChangeState: (value: string) => void;
    previousContainerDetailBool: boolean;
    setPreviousContainerDetailBool: (value: boolean) => void;
    containerChangePopupBool: boolean
    setContainerChangePopupBool: any;
    calculateTotalCargoOnboard: any;
    editValues: any;
    setEditValues: any;
}

const ContainerDetails = ({
    alertBool,
    handleCargoOnboardBlur,
    AmountOfCargoDischagedOnBlur,
    containerChangeState,
    setContainerChangeState,
    previousContainerDetailBool,
    setPreviousContainerDetailBool,
    containerChangePopupBool,
    setContainerChangePopupBool,
    calculateTotalCargoOnboard,
    editValues,
    setEditValues,
}: ContainerDetailsProps) => {
    /** State variables */
    const { discardwarning } = useEditReport();
    const { values, errors, touched, handleChange, handleBlur, setValues, setFieldValue }:
        { values: any, errors: any, touched: any, handleChange: any, handleBlur: any, setValues: any, setFieldValue: any } = useFormikContext<any>();
    const [refresh, setRefresh] = useState(0);
    const { CurrentReport, PreviousReport } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    const containerDetailsPreviousReport = PreviousReport?.data?.deck_officer?.container_detail ?? null;
    /** State variables end */

    /** UseEffect */
    useEffect(() => {
        if (containerChangeState === "no") {
            setValues({
                ...values,
                container_detail: {
                    ...values?.container_detail,
                    reason_for_change: containerDetailsPreviousReport?.reason_for_change,
                    loaded_container: 0,
                    discharged_container: 0,
                    total_onboard_container: containerDetailsPreviousReport?.total_onboard_container,
                    OOG_units: containerDetailsPreviousReport?.OOG_units,
                    feet_20: containerDetailsPreviousReport?.feet_20,
                    feet_40: containerDetailsPreviousReport?.feet_40,
                }
            });
            setRefresh(refresh + 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [containerChangeState])
    useEffect(() => {
        if (editValues && editValues?.deck_officer?.container_detail?.id > 0) {
            setEditValues({
                ...editValues,
                vessel_reporting_information: {
                    ...editValues?.vessel_reporting_information,
                    change_in_containers_onboard: containerChangeState,
                },
                deck_officer: {
                    ...editValues?.deck_officer,
                    container_detail: values?.container_detail
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [values?.container_detail])
    /** UseEffect end */

    return (
        <Card className="mb-0 border-0">
            <CardHeader className="py-2 px-0">
                <div className="text-center">
                    <Row>
                        <Col>
                            <h4 className="page_title pos-start mb-0">
                                Container Details
                            </h4>
                            <p className="card-title-desc pos-start">
                                All readings since last report
                            </p>
                        </Col>
                        <Col>
                            {currentVesselReport?.reporting_event !== ReportingEvents.NOON_FWE_IP &&
                                currentVesselReport?.reporting_event !== ReportingEvents.DEPARTURE_FROM_BERTH &&
                                <div className="d-flex flex-wrap gap-2 pos-end">
                                    <Label for="is_container_change">
                                        Is there any change in no. of containers onboard?
                                    </Label>
                                    <div className="square-switch sqswitch">
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            key={refresh}
                                            type="checkbox"
                                            switch="none"
                                            name="is_container_change"
                                            id="is_container_change"
                                            checked={containerChangeState === "yes" ? true : false}
                                            onChange={(e: any) => {
                                                setFieldValue("container_detail.loaded_container", e.target.checked === true ? null : 0);
                                                setFieldValue("container_detail.discharged_container", e.target.checked === true ? null : 0);
                                                setFieldValue("reefer_container_details.loaded_container", e.target.checked === true ? null : 0);
                                                setFieldValue("reefer_container_details.discharged_container", e.target.checked === true ? null : 0);
                                                if (e.target.checked === true) {
                                                    setContainerChangeState("yes");
                                                    setPreviousContainerDetailBool(true);
                                                } else {
                                                    setContainerChangePopupBool(true);
                                                }
                                            }}
                                        />
                                        <Label
                                            htmlFor="is_container_change"
                                            data-on-label="Yes"
                                            data-off-label="No"
                                        />
                                    </div>
                                </div>
                            }
                        </Col>
                    </Row>
                </div>
            </CardHeader>
            <CardBody className="px-0 py-0 mt-2" >
                <Row className='mb-2'>
                    <div className='ele_row1 d-flex gap-3'>
                        <div>
                            <Label
                                className="asteric mb-0"
                                for="loaded_container"
                            >
                                Total containers loaded
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="loaded_container_msg"
                                />
                            </Label>
                            <ToolTip
                                target="loaded_container_msg"
                                message={`${TooltipMsg.Container_Details.filter(
                                    (item: any) =>
                                        item.target === "loaded_container_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="input-group">
                                <Field name="container_detail.loaded_container">
                                    {({ field, form }: FieldProps) => (
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            key={refresh}
                                            type="text"
                                            className={`form-control text-right max-width-7
                                                ${previousContainerDetailBool && "cursor-not-allowed"}`}
                                            id="loaded_container"
                                            name={field.name}
                                            onBlur={(e: any) => {
                                                handleBlur(e);
                                                if (e.target.value !== null && values?.container_detail?.total_onboard_container !== null) {
                                                    handleCargoOnboardBlur(
                                                        parseFloat(values?.container_detail?.total_onboard_container),
                                                        parseFloat(e.target.value),
                                                        parseFloat(values?.container_detail?.discharged_container)
                                                    );
                                                }
                                                handleChange(e);
                                            }}
                                            onChange={(e: any) => {
                                                handleChange(e);
                                                if (e.target.value === "0") {
                                                    form.setFieldValue(
                                                        "reefer_container_details.loaded_container",
                                                        0
                                                    );
                                                }
                                            }}
                                            value={field.value ?? ""}
                                            disabled={previousContainerDetailBool}
                                        />
                                    )}
                                </Field>
                                <div className="input-group-text round_border">
                                    TEU
                                </div>
                            </div>
                            {errors?.container_detail &&
                                touched?.container_detail?.loaded_container &&
                                errors?.container_detail?.loaded_container &&
                                !alertBool && document.getElementById('loaded_container') &&
                                env?.form_validation === true && !containerChangePopupBool && !discardwarning && (
                                    <ErrorTooltip
                                        target="loaded_container"
                                        message={
                                            errors?.container_detail
                                                ?.loaded_container
                                        }
                                        open={
                                            errors?.container_detail &&
                                                errors?.container_detail
                                                    ?.loaded_container && document.getElementById('loaded_container')
                                                ? true
                                                : false
                                        }
                                    />
                                )}
                        </div>
                        <div>
                            <Label
                                className="asteric mb-0"
                                for="discharged_container"
                            >
                                Total containers discharged
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="discharged_container_msg"
                                />
                            </Label>
                            <ToolTip
                                target="discharged_container_msg"
                                message={`${TooltipMsg.Container_Details.filter(
                                    (item: any) =>
                                        item.target ===
                                        "discharged_container_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="input-group">
                                <Field name="container_detail.discharged_container">
                                    {({ field, form }: FieldProps) => (
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            key={refresh}
                                            type="text"
                                            className={`form-control text-right max-width-7
                                                ${previousContainerDetailBool && "cursor-not-allowed"}`}
                                            id="discharged_container"
                                            name={field.name}
                                            onBlur={(e: any) => {
                                                AmountOfCargoDischagedOnBlur(e, values, handleBlur, handleChange, form)
                                            }}
                                            onChange={(e: any) => {
                                                handleChange(e);
                                                if (e.target.value === "0") {
                                                    form.setFieldValue(
                                                        "reefer_container_details.discharged_container",
                                                        0
                                                    );
                                                }
                                            }}
                                            value={field.value ?? ""}
                                            disabled={previousContainerDetailBool}
                                        />
                                    )}
                                </Field>
                                <div className="input-group-text">TEU</div>
                            </div>
                            {errors?.container_detail &&
                                touched?.container_detail
                                    ?.discharged_container &&
                                errors?.container_detail
                                    ?.discharged_container &&
                                !alertBool && document.getElementById('discharged_container') &&
                                env?.form_validation === true && !containerChangePopupBool && !discardwarning && (
                                    <ErrorTooltip
                                        target="discharged_container"
                                        message={
                                            errors?.container_detail
                                                ?.discharged_container
                                        }
                                        open={
                                            errors?.container_detail &&
                                                errors?.container_detail
                                                    ?.discharged_container && document.getElementById('discharged_container')
                                                ? true
                                                : false
                                        }
                                    />
                                )}
                        </div>
                        <div>
                            <Label
                                className="asteric mb-0"
                                for="total_onboard_container"
                            >
                                Total containers onboard
                                <i
                                    className="bx bx-info-circle ml-2p"
                                    id="total_onboard_container_msg"
                                />
                            </Label>
                            <ToolTip
                                target="total_onboard_container_msg"
                                message={`${TooltipMsg.Container_Details.filter(
                                    (item: any) =>
                                        item.target ===
                                        "total_onboard_container_msg"
                                ).map((tool: any) => {
                                    return tool.message;
                                })}`}
                            />
                            <div className="input-group">
                                <Field name="container_detail.total_onboard_container">
                                    {({ field }: FieldProps) => (
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            key={refresh}
                                            type="text"
                                            id="total_onboard_container"
                                            name={field.name}
                                            className="form-control text-right max-width-7 cursor-not-allowed"
                                            onBlur={(e: any) => {
                                                handleCargoOnboardBlur(
                                                    parseFloat(e.target.value),
                                                    parseFloat(values?.container_detail?.loaded_container),
                                                    parseFloat(values?.container_detail?.discharged_container));
                                                handleBlur(e);
                                            }}
                                            onChange={(e: any) => handleChange(e)}
                                            disabled
                                            value={values?.container_detail?.total_onboard_container}
                                        />
                                    )}
                                </Field>
                                <div className="input-group-text">TEU</div>
                                {errors?.container_detail &&
                                    errors?.container_detail
                                        ?.total_onboard_container &&
                                    !alertBool && document.getElementById('total_onboard_container') &&
                                    env?.form_validation === true && !containerChangePopupBool && !discardwarning && (
                                        <ErrorTooltip
                                            target="total_onboard_container"
                                            message={
                                                errors?.container_detail
                                                    ?.total_onboard_container
                                            }
                                            open={
                                                errors?.container_detail &&
                                                    errors?.container_detail
                                                        ?.total_onboard_container && document.getElementById('total_onboard_container')
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                            </div>
                        </div>
                        <div>
                            <React.Fragment>
                                <Label
                                    className="asteric mb-0"
                                    for="reason_for_change"
                                >
                                    Container details / comments
                                    <i
                                        className="bx bx-info-circle ml-2p"
                                        id="container_detail_msg"
                                    />
                                </Label>
                                <ToolTip
                                    target="container_detail_msg"
                                    message={`${TooltipMsg.Container_Details.filter(
                                        (item: any) =>
                                            item.target === "container_detail_msg"
                                    ).map((tool: any) => {
                                        return tool.message;
                                    })}`}
                                />
                                <span id="container_details_comments">
                                    <Field name="container_detail.reason_for_change">
                                        {() => (
                                            <textarea
                                                key={refresh}
                                                className={`form-control fixed-textarea ${previousContainerDetailBool && "cursor-not-allowed"}`}
                                                name="container_detail.reason_for_change"
                                                id="container_reason_for_change"
                                                rows={
                                                    values?.container_detail?.reason_for_change?.toString()
                                                        ?.length < 10
                                                        ? 1
                                                        : 2
                                                }
                                                onBlur={handleBlur}
                                                onChange={(e: any) => handleChange(e)}
                                                defaultValue={
                                                    values?.container_detail?.reason_for_change
                                                }
                                                disabled={previousContainerDetailBool}
                                            />
                                        )}
                                    </Field>
                                </span>
                                {errors?.container_detail &&
                                    touched?.container_detail?.reason_for_change &&
                                    errors?.container_detail?.reason_for_change &&
                                    !alertBool && document.getElementById("container_reason_for_change") !== null &&
                                    env?.form_validation === true && !containerChangePopupBool && !discardwarning && (
                                        <ErrorTooltip
                                            target="container_reason_for_change"
                                            message={
                                                errors?.container_detail?.reason_for_change
                                            }
                                            open={
                                                errors?.container_detail &&
                                                    errors?.container_detail?.reason_for_change
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                            </React.Fragment>
                        </div>
                    </div>
                </Row>
                <Row className="mb-3">
                    <Col sm={2}>
                        <Label
                            className="mb-0 asteric"
                            for="OOG_units"
                        >
                            OOG units
                            <i
                                className="bx bx-info-circle ml-2p"
                                id="OOG_units_msg"
                            />
                        </Label>
                        <ToolTip
                            target="OOG_units_msg"
                            message={`${TooltipMsg.Container_Details.filter(
                                (item: any) =>
                                    item.target === "OOG_units_msg"
                            ).map((tool: any) => {
                                return tool.message;
                            })}`}
                        />
                        <div className="input-group">
                            <Field name="container_detail.OOG_units">
                                {({ field }: FieldProps) => (
                                    <Input
                                        onFocus={(e) => e.target.select()}
                                        key={refresh}
                                        type="text"
                                        className={`form-control text-right max-width-7
                                                ${previousContainerDetailBool && "cursor-not-allowed"}`}
                                        id="OOG_units"
                                        name={field.name}
                                        onBlur={(e: any) => {
                                            handleBlur(e);
                                            handleChange(e);
                                        }}
                                        onChange={(e: any) => {
                                            handleBlur(e);
                                            handleChange(e);
                                        }}
                                        defaultValue={
                                            values.container_detail.OOG_units
                                        }
                                        disabled={previousContainerDetailBool}
                                    />
                                )}
                            </Field>
                            <div className="input-group-text">Nos</div>
                        </div>
                        {errors?.container_detail &&
                            touched?.container_detail?.OOG_units &&
                            errors?.container_detail?.OOG_units &&
                            !alertBool && !containerChangePopupBool && document.getElementById('OOG_units') &&
                            env?.form_validation === true && !discardwarning && (
                                <ErrorTooltip
                                    target="OOG_units"
                                    message={
                                        errors?.container_detail?.OOG_units
                                    }
                                    open={
                                        errors?.container_detail &&
                                            errors?.container_detail?.OOG_units && document.getElementById('OOG_units')
                                            ? true
                                            : false
                                    }
                                />
                            )}
                    </Col>
                    <Col sm={2}>
                        <Label className="mb-0 asteric" for="feet_20">
                            20 ft units
                            <i className="bx bx-info-circle ml-2p" id="feet_20_info" />
                        </Label>
                        <ToolTip target="feet_20_info" message={`${TooltipMsg.Container_Details.filter(
                            (item: any) =>
                                item.target === "feet_20_info"
                        ).map((tool: any) => {
                            return tool.message;
                        })}`} />
                        <div className="input-group">
                            <Field name="container_detail.feet_20">
                                {({ field }: FieldProps) => (
                                    <Input
                                        onFocus={(e) => e.target.select()}
                                        key={`${refresh}_${containerChangePopupBool}`}
                                        type="text"
                                        className={`form-control text-right ${previousContainerDetailBool && "cursor-not-allowed"}`}
                                        id="feet_20"
                                        {...field}
                                        onBlur={(e: any) => {
                                            handleBlur(e);
                                            calculateTotalCargoOnboard(
                                                parseFloat(e.target.value ?? 0),
                                                parseFloat(values?.container_detail?.feet_40 ?? 0),
                                                setFieldValue,
                                                "container_detail.total_onboard_container"
                                            );
                                        }}
                                        onChange={(e: any) => {
                                            handleChange(e);
                                            calculateTotalCargoOnboard(
                                                parseFloat(e.target.value ?? 0),
                                                parseFloat(values?.container_detail?.feet_40 ?? 0),
                                                setFieldValue,
                                                "container_detail.total_onboard_container"
                                            );
                                        }}
                                        defaultValue={values.container_detail?.feet_20 ?? ""}
                                        disabled={previousContainerDetailBool}
                                    />
                                )}
                            </Field>
                            <div className="input-group-text round_border">
                                Nos
                            </div>
                            {errors?.container_detail &&
                                touched?.container_detail?.feet_20 &&
                                errors?.container_detail?.feet_20 &&
                                !alertBool && document.getElementById('feet_20') &&
                                env?.form_validation === true && !containerChangePopupBool && !discardwarning && (
                                    <ErrorTooltip
                                        key={`${refresh}_${containerChangePopupBool}`}
                                        target="feet_20"
                                        message={errors.container_detail?.feet_20}
                                        open={errors?.container_detail?.feet_20 ? true : false}
                                    />
                                )}
                        </div>
                    </Col>
                    <Col sm={2}>
                        <Label className="mb-0 asteric" for="feet_40">
                            40 ft units
                            <i className="bx bx-info-circle ml-2p" id="feet_40_info" />
                        </Label>

                        <ToolTip
                            target="feet_40_info"
                            message={`${TooltipMsg.Container_Details.filter(
                                (item: any) =>
                                    item.target === "feet_40_info"
                            ).map((tool: any) => {
                                return tool.message;
                            })}`}
                        />
                        <div className="input-group">
                            <Field name="container_detail.feet_40">
                                {({ field }: FieldProps) => (
                                    <Input
                                        onFocus={(e) => e.target.select()}
                                        key={`${refresh}_${containerChangePopupBool}`}
                                        type="text"
                                        className={`form-control text-right ${previousContainerDetailBool && "cursor-not-allowed"}`}
                                        id="feet_40"
                                        {...field}
                                        onBlur={(e: any) => {
                                            handleBlur(e);
                                            calculateTotalCargoOnboard(
                                                parseFloat(values?.container_detail?.feet_20 ?? 0),
                                                parseFloat(e.target.value ?? 0),
                                                setFieldValue,
                                                "container_detail.total_onboard_container"
                                            );
                                        }}
                                        onChange={(e: any) => {
                                            handleChange(e);
                                            calculateTotalCargoOnboard(
                                                parseFloat(values?.container_detail?.feet_20 ?? 0),
                                                parseFloat(e.target.value ?? 0),
                                                setFieldValue,
                                                "container_detail.total_onboard_container"
                                            );
                                        }}
                                        defaultValue={values.container_detail?.feet_40 ?? ""}
                                        disabled={previousContainerDetailBool}
                                    />
                                )}
                            </Field>
                            <div className="input-group-text round_border">Nos</div>
                            {errors?.container_detail &&
                                touched?.container_detail?.feet_40 &&
                                errors?.container_detail?.feet_40 &&
                                !alertBool && document.getElementById('feet_40') &&
                                env?.form_validation === true && !containerChangePopupBool && !discardwarning && (
                                    <ErrorTooltip
                                        key={`${refresh}_${containerChangePopupBool}`}
                                        target="feet_40"
                                        message={errors.container_detail?.feet_40}
                                        open={errors?.container_detail?.feet_40 ? true : false}
                                    />
                                )}
                        </div>
                    </Col>
                </Row>
            </CardBody>
            <PopUp
                state={containerChangePopupBool}
                setState={setContainerChangePopupBool}
                title={"Container Change"}
                size={"sm"}
                body={
                    <React.Fragment>
                        <p className="mb-3">
                            By selecting <strong>'No change in no. of containers onboard</strong>, the current details will be replaced with those from the previous report.
                            <br /><br />
                            Do you agree to proceed with this change?
                        </p>
                        <div className="d-flex justify-content-end gap-2">
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setValues({
                                        ...values,
                                        container_detail: {
                                            ...values?.container_detail,
                                            reason_for_change: containerDetailsPreviousReport?.reason_for_change,
                                            loaded_container: 0,
                                            discharged_container: 0,
                                            total_onboard_container: containerDetailsPreviousReport?.total_onboard_container,
                                            OOG_units: containerDetailsPreviousReport?.OOG_units,
                                            feet_20: containerDetailsPreviousReport?.feet_20,
                                            feet_40: containerDetailsPreviousReport?.feet_40,
                                        }
                                    });
                                    setRefresh(refresh + 1);
                                    setContainerChangePopupBool(false);
                                    setContainerChangeState("no");
                                    if ((currentVesselReport?.reporting_event !== ReportingEvents.NOON_FWE_IP &&
                                        currentVesselReport?.reporting_event !== ReportingEvents.DEPARTURE_FROM_BERTH &&
                                        containerChangeState === "no")) {
                                        setPreviousContainerDetailBool(false);
                                    } else {
                                        setPreviousContainerDetailBool(true);
                                    }
                                    setRefresh(refresh + 1);
                                }}
                            >
                                Yes
                            </button>
                            <button
                                className="btn btn-danger"
                                onClick={() => {
                                    setContainerChangePopupBool(false);
                                    setRefresh(refresh + 1);
                                }}
                            >
                                No
                            </button>
                        </div>
                    </React.Fragment>
                }
            />
        </Card>
    )
}

export default ContainerDetails